<template>
    <div
        :class="{
            'lbx-carousel': !allOptions.disableStyles,
            'lbx-carousel--with-arrows': currentOptions.arrows && !isLimited,
            'lbx-carousel--with-pager': currentOptions.pagination && !isLimited,
            'lbx-carousel--limited': isLimited
        }"
        :style="cssVars"
    >
        <div
            ref="splideEl"
            class="lbxsplide"
        >
            <div class="lbxsplide__arrows">
                <div
                    class="lbx-carousel__arrow lbx-carousel__arrow--prev
                        lbxsplide__arrow lbxsplide__arrow--prev"
                    :title="$t('carousel.prev')"
                >
                    {{ $t('carousel.prev') }}
                </div>
                <div
                    class="lbx-carousel__arrow lbx-carousel__arrow--next
                        lbxsplide__arrow lbxsplide__arrow--next"
                    :title="$t('carousel.next')"
                >
                    {{ $t('carousel.next') }}
                </div>
            </div>
            <div class="lbxsplide__track">
                <div class="lbxsplide__list">
                    <div
                        v-for="item in computedItems"
                        :key="name.concat('-').concat(item.url)"
                        class="lbx-carousel__item lbxsplide__slide lbxslick-slide"
                        :class="{'lbxsplide__nodrag': isLimited}"
                    >
                        <recommend-item
                            :is="component"
                            :class="allOptions.itemClass"
                            :item="item"
                            @hook:mounted="itemMounted(item)"
                        ></recommend-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Splide from 'lbxsplide';
import cloneDeep from 'clone-deep';

import { LUIGIS } from '../constants';

export default {
    props: {
        items: {
            type: Array,
            default: () => null,
        },
        options: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            mountedItems: 0,
            splide: null,
            splideMounted: false,
            currentOptions: {},
        };
    },
    computed: {
        ...mapState([
            'name',
            'carouselOptions',
        ]),
        ...mapState({
            itemsFromStore: state => state.items,
        }),
        isLimited() {
            return this.currentOptions.perPage === this.computedItems.length
                && this.allOptions.limitItems;
        },
        cssVars() {
            return {
                '--carousel-color': this.allOptions.color,
            };
        },
        component() {
            if (this.name && this.name !== LUIGIS.DEFAULT_NAME) {
                return `recommend-item-${this.name}`;
            }

            return 'recommend-item';
        },
        computedItems() {
            if (Array.isArray(this.items)) {
                return this.items;
            }
            return this.itemsFromStore;
        },
        allOptions() {
            return {
                ...this.carouselOptions,
                ...this.options,
            };
        },
        transformedOptions() {
            return this.transformOptions(this.allOptions, this.allOptions);
        },
    },
    watch: {
        mountedItems(val) {
            if (val === this.computedItems.length) {
                this.initCarousel();
            }
        },
    },
    methods: {
        transformOptions(options) {
            // eslint-disable-next-line no-param-reassign
            options = cloneDeep(options);
            const keys = Object.keys(options);
            const newOptions = {
                dotsClass: 'lbx-carousel__pager',
            };
            for (let i = 0; i < keys.length; i += 1) {
                const key = keys[i];
                const option = options[key];
                switch (key) {
                case 'responsive':
                    if (typeof option === 'object') {
                        const keys = Object.keys(option);
                        for (let i = 0; i < keys.length; i += 1) {
                            option[keys[i]] = this.transformOptions(option[keys[i]]);
                        }
                        newOptions.breakpoints = option;
                    }
                    break;
                case 'infinite':
                    newOptions.type = option ? 'loop' : 'slide';
                    break;
                case 'items':
                    // eslint-disable-next-line no-nested-ternary
                    newOptions.perPage = this.allOptions.limitItems
                        ? (option > this.computedItems.length ? this.computedItems.length : option)
                        : option;
                    break;
                case 'focus':
                    newOptions.focus = option;
                    break;
                case 'moveBy':
                    newOptions.perMove = option;
                    break;
                case 'arrows':
                    newOptions.arrows = option;
                    break;
                case 'pager':
                    newOptions.pagination = option;
                    break;
                case 'pauseOnFocus':
                    newOptions.pauseOnFocus = option;
                    break;
                case 'forcePerMove':
                    newOptions.forcePerMove = option;
                    break;
                case 'pauseOnHover':
                    newOptions.pauseOnHover = option;
                    break;
                case 'autoPlay':
                    if (option > 0) {
                        newOptions.autoplay = true;
                        newOptions.interval = option;
                    }
                    break;
                case 'disableStyles':
                    break;
                case 'limitItems':
                    break;
                case 'color':
                    break;
                case 'itemClass':
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.log(`⚠️ Unknown LBX Carousel option - ${key}`);
                    newOptions[key] = option;
                }
            }
            newOptions.noDrag = '.lbxsplide__nodrag, .lbxsplide__nodrag *';
            return newOptions;
        },
        itemMounted() {
            this.mountedItems += 1;
        },
        goToSlide(index) {
            if (!this.splideMounted) {
                return;
            }
            this.splide.go(index);
        },
        initCarousel() {
            // setTimeout(() => {
            this.currentOptions = { ...this.transformedOptions };
            this.splide = new Splide(this.$refs.splideEl, this.transformedOptions);
            this.splide.on('updated', (options) => {
                this.currentOptions = options;
            });
            this.splide.on('pagination:mounted', (data) => {
                data.items.forEach((item) => {
                    item.button.classList.add('lbx-carousel__pager-dot');
                    item.button.textContent = String(item.page + 1);
                });
            });
            this.currentOptions = { ...this.splide.options };
            this.$nextTick(() => {
                this.splide.mount();
                this.currentOptions = { ...this.splide.options };
                this.splideMounted = true;
            });
            // }, 1);
        },
    },
};
/* eslint-disable max-len */
</script>
